module.exports = __webpack_public_path__ + "img/pixel_wallet.d67f7ce6.svg";